import type {
  TaskTrackerBoardAccessMember,
  TaskTrackerBoardAccessMode,
} from '../store/taskTracker.types'

type TaskTrackerBoardAccessCacheEntry = {
  accessMode: TaskTrackerBoardAccessMode
  selectedMembers: TaskTrackerBoardAccessMember[]
}

const boardAccessCache = new Map<number, TaskTrackerBoardAccessCacheEntry>()

export const getTaskTrackerBoardAccessCache = (boardId: number) =>
  boardAccessCache.get(boardId)

export const setTaskTrackerBoardAccessCache = (
  boardId: number,
  entry: TaskTrackerBoardAccessCacheEntry,
) => {
  boardAccessCache.set(boardId, entry)
}

export const clearTaskTrackerBoardAccessCache = (boardId: number) => {
  boardAccessCache.delete(boardId)
}
